import { Component } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-orderhead-external-cost',
    templateUrl: './orderhead-external-cost.component.html',
    styleUrls: ['./orderhead-external-cost.component.css'],
})
export class OrderheadExternalCostComponent {
    private orderInternalNo: string;

    public grid: GridOptions = new Grid().setRememberId('w_orderheadexternalcost.grid').setLoadDataFunction({ method: 3690, parameters: () => ({ order_internal_no: this.orderInternalNo }) });

    constructor(state: StateService) {
        this.orderInternalNo = state.getStateParams()['order_internal_no'];
    }
}
